import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../user/pages/UserSignIn.vue";
import i18n from "../locales/i18n.js";
import landlord from "./module/landlord";
import vuetify from "../plugins/vuetify";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/dashboard"
  },
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
    meta: { display: false, redirectAuthUser: true }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../user/pages/Dashboard.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customer",
    name: "Customer",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/user/pages/Customer.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/otp",
    name: "Otp",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/user/pages/Otp.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/privacy_policy",
    name: "privacyPolicy",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/user/pages/PrivacyPolicy.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(
        /* webpackChunkName: "AppSettings" */ "@/settings/pages/AppSettings.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/properties",
    name: "Properties",
    component: () =>
      import(
        /* webpackChunkName: "AllProperties" */ "@/all-properties/pages/AllProperties.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/payments",
    name: "Payments",
    component: () =>
      import(
        /* webpackChunkName: "Payments" */ "@/payments/pages/Payments.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/bookings",
    name: "Bookings",
    component: () =>
      import(
        /* webpackChunkName: "bookings" */ "@/bookings/pages/Bookings.vue"
      ),
    meta: { requiresAuth: true }
  },

  {
    path: "/landlord_plans",
    name: "Plans",
    component: () =>
      import(/* webpackChunkName: "bookings" */ "@/plans/pages/plans.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/landlord_subscriptions",
    name: "Subscriptions",
    component: () =>
      import(
        /* webpackChunkName: "bookings" */ "@/subscriptions/pages/subscriptions.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/landlord_billings",
    name: "Billings",
    component: () =>
      import(/* webpackChunkName: "bookings" */ "@/billing/pages/billings.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/requested_landlord",
    name: "RequestedLandlord",
    component: () =>
      import(
        /* webpackChunkName: "bookings" */ "@/landlord/pages/LandlordRequest.vue"
      ),
    meta: { requiresAuth: true }
  },
   {
    path: "/contact_requests",
    name: "ContactRequests",
    component: () =>
      import(
        /* webpackChunkName: "bookings" */ "@/landlord/pages/ContactRequests.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/property",
    name: "Property",
    component: () =>
      import(
        /* webpackChunkName: "property" */ "@/property/pages/Property.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/payment/:id",
    name: "Payment",
    component: () =>
      import(/* webpackChunkName: "property" */ "@/user/pages/Payment.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customerContract/:id",
    name: "BookingPdf",
    component: () =>
      import(
        /* webpackChunkName: "property" */ "@/bookings/pages/BookingPdf.vue"
      )
  },
  {
    path: "/promoted_landlords",
    name: "promotedLandlords",
    component: () =>
      import(
        /* webpackChunkName: "property" */ "@/promotions/pages/PromotedLandlords.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/contract",
    name: "Contract",
    component: () =>
      import(
        /* webpackChunkName: "property" */ "@/contract/pages/Contract.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/terms_and_condition",
    name: "TermsAndCondition",
    component: () =>
      import(
        /* webpackChunkName: "property" */ "@/user/pages/TermsAndCondition.vue"
      ),
    meta: { requiresAuth: true }
  },
  ...landlord
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const auth = localStorage.getItem("apollo-done-token");
  let language = to.params.lang;
  if (!language) {
    language = localStorage.getItem("RENTAL_APP_LANG") || "en";
  }
  vuetify.rtl = language === "en" ? false : true;
  i18n.locale = language;

  // redirect unauth users to Signin  page
  if (to.meta.requiresAuth && !auth) {
    next({ name: "SignIn", params: { lang: i18n.locale } });
  } else if (to.meta.redirectAuthUser && auth) {
    // redirect Dashboard page for autheticated users
    next({ name: "Dashboard", params: { lang: i18n.locale } });
  } else {
    next();
  }
});

export default router;
